import apiClient from './api';

export interface WelcomeVideoConfig {
  enabled: boolean;
  embedUrl: string;
}

export interface AppConfig {
  welcomeVideo: WelcomeVideoConfig;
}

let cached: AppConfig | null = null;

async function getAppConfig(): Promise<AppConfig> {
  if (cached) return cached;

  const response = await apiClient.get<AppConfig>('/api/app-config');
  cached = response.data;
  return cached;
}

export default { getAppConfig };
